import React, { ButtonHTMLAttributes } from 'react';

import styled from 'styled-components';

import { ThemeDetails } from '../tokens/button.js';
import { ButtonLoader } from '../svg/buttonLoader.jsx';
import {
	getButtonDetailsBySize,
	getButtonDetailsByTheme,
} from '../helper/buttonUtils.js';

const StyledButton = styled.button`
	// <StyledButtonProps> TODO: Fix me when typesafe
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
	flex-direction: ${({ $iconPosition }) =>
		$iconPosition === 'front' ? 'row' : 'row-reverse'};
	${({ $size, $iconPresent }) =>
		getButtonDetailsBySize({ size: $size, iconPresent: $iconPresent })}
	${({ $color, $variant, $isLoading, disabled }) =>
		getButtonDetailsByTheme({
			color: $color,
			variant: $variant,
			isLoading: $isLoading,
			disabled,
		})}
	${({ $isLoading }) => $isLoading && 'padding: 0;'}
	width: ${({ $width }) => $width};
	height: ${({ $height }) => $height};
`;

const Button = ({
	size,
	color,
	variant,
	icon,
	text,
	className,
	onClick,
	loadingText,
	iconPosition = 'front',
	width = '100%',
	height,
	isLoading = false,
	disabled = false,
	...props
	// : ButtonProps & ButtonHTMLAttributes<HTMLButtonElement> TODO: Fix me when typesafe
}) => {
	const themeColor = ThemeDetails[color]; //const themeColor = ThemeDetails[color] as Record<PrimaryVariants | SecondaryVariants, ThemeDetailType>; TODO: Fix me when typesafe
	const themeDetail = themeColor[variant];
	return (
		<StyledButton
			className={className}
			onClick={onClick && !isLoading && !disabled ? onClick : () => {}}
			disabled={disabled}
			aria-label={text}
			aria-disabled={disabled}
			aria-busy={isLoading}
			$size={size}
			$color={color}
			$variant={variant}
			$iconPosition={iconPosition}
			$width={width}
			$height={height}
			$iconPresent={icon ? true : false}
			$isLoading={isLoading}
			{...props}
		>
			{isLoading ? (
				<>
					<ButtonLoader color={themeDetail.fontColor} />
					{loadingText}
				</>
			) : (
				<>
					{icon && <span>{icon}</span>}
					{text}
				</>
			)}
		</StyledButton>
	);
};

export default Button;
